import { Row } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'

interface ProductsCountSectionProps {
  count: number
  hasActiveSearch: boolean
}

export const ProductsCountSection = ({
  count,
  hasActiveSearch,
}: ProductsCountSectionProps) => {
  const { t } = useLocalization()

  if (count === 0) return null

  return (
    <Row className="px-1 py-3 text-sm">
      <span className="font-medium text-foreground">
        {count.toLocaleString()} {t('products', 'produkter')}
      </span>
      {hasActiveSearch && (
        <span className="ml-2 text-muted-foreground">
          ({t('filtered', 'filtrerat')})
        </span>
      )}
    </Row>
  )
}

